export const WmsItemsStatus = {
    NEW: 'new',
    PENDING: 'pending',
    PICKING: 'picking',
    NOT_FOUND: 'not_found',
    IN_TROLLEY: 'in_trolley',
    READY_TO_BE_SORTED: 'ready_to_be_sorted',
    SORTED: 'sorted',
    READY_TO_BE_PACKED: 'ready_to_be_packed',
    PACKING: 'packing',
    PACKED: 'packed',
    READY_TO_BE_SHIPPED: 'ready_to_be_shipped',
    SHIPPED: 'shipped',
    WAITING_FOR_RECEPTION: 'waiting_for_reception',
    CLICK_COLLECT_READY: 'click_collect_ready',
    CLICK_COLLECT_COLLECTED: 'click_collect_collected',
    CLICK_COLLECT_CANCELLED: 'click_collect_canceled',
    RETURNED_VERIFICATION: 'returned_verification',
    RETURN_CANCELLED: 'return_cancelled',
    RETURNED: 'returned',
    CANCELED: 'cancelled',
    SPECIAL: 'special'
}

export function getBaseWmsItemsStatus() {
    return [
        WmsItemsStatus.NEW,
        WmsItemsStatus.PENDING,
        WmsItemsStatus.PICKING,
        WmsItemsStatus.NOT_FOUND,
        WmsItemsStatus.IN_TROLLEY,
        WmsItemsStatus.READY_TO_BE_SORTED,
        WmsItemsStatus.SORTED,
        WmsItemsStatus.READY_TO_BE_PACKED,
        WmsItemsStatus.PACKING,
        WmsItemsStatus.PACKED,
        WmsItemsStatus.READY_TO_BE_SHIPPED,
        WmsItemsStatus.SHIPPED,
        WmsItemsStatus.CANCELED
    ]

}
export function getDashboardWmsItemsStatus() {
    return [
        WmsItemsStatus.PENDING,
        WmsItemsStatus.READY_TO_BE_SORTED,
        WmsItemsStatus.READY_TO_BE_PACKED,
        WmsItemsStatus.READY_TO_BE_SHIPPED,
    ]
}

export function getReturnWmsItemsStatus() {
    return [
        WmsItemsStatus.RETURNED_VERIFICATION,
        WmsItemsStatus.RETURN_CANCELLED,
        WmsItemsStatus.RETURNED,
        WmsItemsStatus.WAITING_FOR_RECEPTION
    ]
}

export function getClickAndCollectWmsItemsStatus() {
    return [
        WmsItemsStatus.CLICK_COLLECT_VALIDATION,
        WmsItemsStatus.CLICK_COLLECT_READY,
        WmsItemsStatus.CLICK_COLLECT_COLLECTED,
        WmsItemsStatus.CLICK_COLLECT_CANCELLED,
        WmsItemsStatus.WAITING_FOR_RECEPTION
    ]
}